import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type { VendorMaterialPricingPlan } from '../types';
import type { UseBulkVendorsQuoteRequestBody } from './types';

export const useBulkVendorsQuoteRequest: MutationFunction<
  VendorMaterialPricingPlan,
  UseBulkVendorsQuoteRequestBody
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation(
    ({ ...body }) =>
      request('/vendors/request_quotes', {
        query,
        init: {
          method: 'POST',
          body,
        },
      }),
    queryOptions,
  );
};
